import styled from "styled-components";

export const RowContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	margin-bottom: 3rem;
`;

export const Title = styled.h1`
	font-size: 20px;
	font-weight: 700;
	line-height: 23px;
	color: #31475a !important;
`;

export const MessageContainer = styled.div`
	display: flex;
	height: 150px;
	flex-direction: column;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 3rem;
`;

export const MessageTitle = styled.div`
	font-size: 20px;
	font-weight: 700;
	color: #31475a;
`;

export const MessageText = styled.div`
	width: 450px;
	text-align: center;
	font-size: 16px;
	color: #31475a;
`;

export const IconContainer = styled.div`
	width: 64px;
	height: 64px;
	border-radius: 8px;
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const ButtonsContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 16px;
`;

export const Button = styled.button`
	width: 239px;
	height: 39px;
	background-color: ${props => (props.primary ? "#534B99" : "white")};
	color: ${props => (props.primary ? "white" : "#534B99")};
	border: ${props => (props.primary ? "none" : "1px solid #534B99")};
	border-radius: 8px;
	padding: 8px 32px;
	font-weight: 700;
`;
